import { render, staticRenderFns } from "./LoaderNew.htm?vue&type=template&id=7e681884&scoped=true&"
import script from "./LoaderNew.js?vue&type=script&lang=js&"
export * from "./LoaderNew.js?vue&type=script&lang=js&"
import style0 from "./LoaderNew.scss?vue&type=style&index=0&id=7e681884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e681884",
  null
  
)

export default component.exports